// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"Section_sectionContainer__mLo40","actionButtons":"Section_actionButtons__qgIVL","sectionContainer--spacious":"Section_sectionContainer--spacious__x0vTQ"};